export default {
	NONE: 'none', // 팝업 닫기 설정 안함
	NO_MORE_TODAY: 'no_more_today', // 오늘 하루 보지 않기
	NEVER: 'never', // 다시 보지 않기
};
